import axios from 'axios';
import { get, pickBy } from 'lodash';

export function getConfigString(key: string) {
  const podName = process.env.REACT_APP_POD_NAME;
  const value = process.env[key] && `${process.env[key]}`;

  if (podName === 'partner') {
    const {
      location: { href },
    } = window;
    const partnerNameList =
      process.env.REACT_APP_PARTNER_NAME_LIST?.split(',') || [];
    const domainPartner = partnerNameList.find((partnerName) =>
      href.includes(partnerName),
    );
    const partnerValue =
      domainPartner && value?.replace('partner', domainPartner);
    const isLocalHost = href.includes('localhost');
    const localHostValue = value?.replace('partner', 'red');

    return isLocalHost ? localHostValue : partnerValue;
  }

  return value;
}

function getApiBasePath() {
  const appPrefix = getConfigString('REACT_APP_PREFIX');
  const isPatientApp = appPrefix === 'lh_patient';
  return isPatientApp
    ? getConfigString('REACT_APP_API_PATIENT')
    : getConfigString('REACT_APP_API_BASE');
}

export function getToken() {
  const appPrefix = getConfigString('REACT_APP_PREFIX');
  const tokenKey = `${appPrefix}:auth_token`;
  const userKey = `${appPrefix}:auth_user`;
  const localUserKey = localStorage.getItem(userKey) || '';
  const localStorageToken = localStorage.getItem(tokenKey);
  let token;
  try {
    if (localStorageToken) {
      const parsedToken = localStorageToken
        ? JSON.parse(localStorageToken)
        : '';
      token = parsedToken;
    } else if (localUserKey) {
      const authUser = JSON.parse(localUserKey);
      token = get(authUser, 'token');
    } else {
      token = '';
    }
  } catch (error) {
    console.error(error); // We don't have a token so we can't log this
  }

  return token;
}

const axiosService = axios.create({
  baseURL: getApiBasePath(),
});

axiosService.interceptors.request.use((config) => {
  const isOnEmbedPage = /\/embed\//.test(window.location.href);
  return {
    ...config,
    headers: pickBy({
      ...(isOnEmbedPage
        ? {}
        : { 'x-access-token': (window as any).token || getToken() }),
      ...config.headers,
    }),
  };
});

export const recentlyUsedInterceptor = axiosService.interceptors.response.use(
  (data) => data,
  (error) =>
    Promise.reject(error).finally(() => {
      if (get(error, 'response.config.ignoreError')) {
        return;
      }

      // patient forms call returns a valid payload with an error code. ????
      if (get(error, 'response.status') === 409) {
        return get(error, 'data.error.message');
      }

      // Redirect on 401 errors
      if (get(error, 'response.status') === 401) {
        window.location.href = `${window.location.origin}/login`;
      }
    }),
);

export { axiosService };
